// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';

import type { ThemeOptions } from '@mui/material/styles';

import customShadows from './customShadows';
import GlobalStyles from './globalStyles';
import componentsOverride from './overrides/index';
import palette from './palette';
import shadows from './shadows';
import typography from './typography';

interface Props {
  children: React.ReactNode;
}

export default function ThemeProvider({ children }: Props) {
  const themeOptions: ThemeOptions = useMemo(
    () => ({
      cssVariables: true,
      palette: palette(),
      typography,
      shape: { borderRadius: 8 },
      shadows: shadows(),
      customShadows: customShadows(),
      breakpoints: {
        keys: [
          'xxs',
          'xs',
          'sm',
          'md',
          'lg',
          'xl',
          'xxl',
          'xxxl',
          'fullHD',
          'largeDesktop',
          'ultraWide',
          'displayMax',
        ],
        values: {
          xxs: 0, // Smallest phones
          xs: 375, // iPhone SE, small smartphones
          sm: 480, // Larger smartphones
          md: 640, // Larger smartphones, small tablets

          // Tablet sizes
          lg: 768, // iPad, standard tablets
          xl: 1024, // Large tablets, small desktops

          // Desktop sizes
          xxl: 1280, // Standard laptops
          xxxl: 1440, // Large laptops
          fullHD: 1600, // High-resolution desktops
          largeDesktop: 1920, // Large desktop monitors

          // Ultra-wide and 4K displays
          ultraWide: 2560, // Ultra-wide monitors
          displayMax: 3840, // 4K displays
        },
      },
    }),
    [],
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      {children}
    </MUIThemeProvider>
  );
}
